export { default } from './ProductDetailsPage';
export { pdpReducerKey, pdpReducer } from './state';
